import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { memo, useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { batchPatchUserBadgeExpirationDate } from "rest-data-provider/utils/tools";

interface PropsType {
  selectedRows: any[];
  refresh: (_date: string) => void;
}

export const UpdateExpirationDate = memo((props: PropsType) => {
  const { selectedRows, refresh } = props;

  const [open, setOpen] = useState(false);
  const [expirationDate, setExpirationDate] = useState("");

  useEffect(() => {
    setExpirationDate("");
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  const save = async () => {
    if (!expirationDate) return;

    await batchPatchUserBadgeExpirationDate("user-badges", {
      ids: selectedRows.map((e) => e.id),
      expirationDate,
    });

    handleClose();
    refresh(expirationDate);
  };

  const expirationDateChangeHandler = (e: any) => {
    setExpirationDate(e.format("YYYY-MM-DD"));
  };

  return (
    <div>
      <Button
        onClick={() => {
          if (selectedRows.length === 0) return;
          setOpen(true);
        }}
        style={{
          backgroundColor: "#1976d2",
          color: "#fff",
          height: "40px",
          padding: "6px 16px",
        }}
      >
        Update Expiration Date
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="responsive-dialog-title">
          Update Expiration Date
        </DialogTitle>
        <DialogContent>
          <DatePicker onChange={expirationDateChangeHandler} />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={save}>SAVE</Button>
          <Button color="error" onClick={handleClose}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
